<template>
<div class="chapter">
<div class="inner_page">
<div class="story">
<p class="para"><span class="bold">Also by Loren Cordain</span></p>
<p class="para"><em class="italic">The Paleo Diet</em></p>
<p class="para"><em class="italic">The Paleo Diet Cookbook</em> (with Lorrie Cordain and Nell Stephenson)</p>
<p class="para"><em class="italic">The Paleo Diet for Athletes</em> (with Joe Friel)</p>
<p class="para"><em class="italic">The Dietary Cure for Acne</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fm01.vue?20e6eb32